/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { slackDirectoryConnectionsDisconnect } from "../funcs/slackDirectoryConnectionsDisconnect.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SlackDirectoryConnection } from "../models/components/slackdirectoryconnection.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DisconnectSlackDirectoryConnectionRequest,
  DisconnectSlackDirectoryConnectionSecurity,
} from "../models/operations/disconnectslackdirectoryconnection.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DisconnectSlackDirectoryConnectionMutationVariables = {
  request: DisconnectSlackDirectoryConnectionRequest;
  security?: DisconnectSlackDirectoryConnectionSecurity | undefined;
  options?: RequestOptions;
};

export type DisconnectSlackDirectoryConnectionMutationData =
  SlackDirectoryConnection;

export type DisconnectSlackDirectoryConnectionMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * disconnect slackDirectoryConnections
 */
export function useDisconnectSlackDirectoryConnectionMutation(
  options?: MutationHookOptions<
    DisconnectSlackDirectoryConnectionMutationData,
    DisconnectSlackDirectoryConnectionMutationError,
    DisconnectSlackDirectoryConnectionMutationVariables
  >,
): UseMutationResult<
  DisconnectSlackDirectoryConnectionMutationData,
  DisconnectSlackDirectoryConnectionMutationError,
  DisconnectSlackDirectoryConnectionMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDisconnectSlackDirectoryConnectionMutation(client, options),
    ...options,
  });
}

export function mutationKeyDisconnectSlackDirectoryConnection(): MutationKey {
  return ["@gram/client", "slackDirectoryConnections", "disconnect"];
}

export function buildDisconnectSlackDirectoryConnectionMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DisconnectSlackDirectoryConnectionMutationVariables,
  ) => Promise<DisconnectSlackDirectoryConnectionMutationData>;
} {
  return {
    mutationKey: mutationKeyDisconnectSlackDirectoryConnection(),
    mutationFn: function disconnectSlackDirectoryConnectionMutationFn({
      request,
      security,
      options,
    }): Promise<DisconnectSlackDirectoryConnectionMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(slackDirectoryConnectionsDisconnect(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
